import React, { useMemo } from "react";
import BaseNode from "./BaseNode";
import type { HandleProps, NodeProps } from "./types";
import { Position } from "@xyflow/react";
import { Input } from "../ui/input";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../ui/select";
import FormField from "@/components/FormField";
import { PencilLineIcon } from "lucide-react";
import useNodeField from "@/hooks/useNodeField";

const InputNode: React.FC<NodeProps> = (props) => {
  const [fieldValue, setFieldValue] = useNodeField<string>(
    props.id,
    "fieldName",
    props.data?.fieldName || props.id,
  );
  const [fieldType, setFieldType] = useNodeField<string>(
    props.id,
    "fieldType",
    props.data?.fieldType || "text",
  );

  const handles: HandleProps[] = useMemo(
    () => [
      {
        type: "source",
        position: Position.Right,
        id: fieldValue,
        label: fieldValue,
      },
    ],
    [fieldValue],
  );

  return (
    <BaseNode
      title="Input"
      icon={<PencilLineIcon size={16} />}
      handles={handles}
      {...props}
    >
      <FormField label="Field name">
        <Input
          name="field-name"
          value={fieldValue}
          onChange={(e) => setFieldValue(e.target.value)}
        />
      </FormField>
      <FormField label="Type">
        <Select value={fieldType} onValueChange={setFieldType}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Theme" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="text">Text</SelectItem>
            <SelectItem value="file">File</SelectItem>
            <SelectItem value="audio">Audio</SelectItem>
          </SelectContent>
        </Select>
      </FormField>
    </BaseNode>
  );
};

export default InputNode;
